export const LegalStatusService = Symbol.for('LegalStatusService');
